import axios from "axios";
import router from "@/router";
import { Message } from "element-ui";
axios.interceptors.request.use(
  config => {
    return config;
  },
  err => {
    Message({
      message: "服务器繁忙，请稍后再试~",
      type: "warning",
      showClose: true
    });
    return Promise.resolve(err);
  }
);
axios.interceptors.response.use(
  data => {
    if (data.status && data.status == 200) {
      if (data.data.status == "TX0000") {
        return data.data;
      } else {
        //			Message.warning('服务器繁忙，请稍后再试~');
        return data.data;
      }
    }
    return data;
  },
  err => {
    Message({
      message: "服务器繁忙，请稍后再试~",
      type: "warning",
      showClose: true
    });
    return Promise.resolve(err);
  }
);

let base = process.env.NODE_ENV === "development" ? "/api" : "/api";
var CancelToken = axios.CancelToken;
var cancel;
// 取消
export const cancelRequest = () => {
  cancel && cancel();
};

//let jsonpBase = "http://221.122.73.84:8600";
export const postRequest = (url, params) => {
  cancelRequest();
  return axios({
    method: "post",
    url: `${base}${url}`,
    data: params,
    transformRequest: [
      function (data) {
        let ret = "";
        for (let it in data) {
          ret +=
            encodeURIComponent(it) +
            "=" +
            encodeURIComponent(data[it]) +
            "&";
        }
        return ret;
      }
    ],
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    cancelToken: new CancelToken(function executor (c) {
      // executor 函数接收一个 cancel 函数作为参数
      cancel = c;
    })
  });
};
export const uploadFileRequest = (url, params) => {
  return axios({
    method: "post",
    url: `${base}${url}`,
    data: params,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};
// post json
export const postJsonRequest = (url, params) => {
  return axios({
    method: "post",
    url: `${base}${url}`,
    data: params,
    headers: {
      "Content-Type": "application/json;charset=UTF-8"
    },
  });
};
export const putRequest = (url, params) => {
  return axios({
    method: "put",
    url: `${base}${url}`,
    data: params,
    transformRequest: [
      function (data) {
        let ret = "";
        for (let it in data) {
          ret +=
            encodeURIComponent(it) +
            "=" +
            encodeURIComponent(data[it]) +
            "&";
        }
        return ret;
      }
    ],
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
};
export const deleteRequest = url => {
  return axios({ method: "delete", url: `${base}${url}` });
};
export const getRequest = (url, params) => {
  return axios({ method: "get", url: `${base}${url}`, params: params });
};

var parseParam = function (param, key) {
  var paramStr = "";
  for (let i in param) {
    paramStr += "&" + i + "=" + encodeURIComponent(param[i]);
  }
  return paramStr.substr(1);
};
